export default {
  GET_CATEGORIES: ({ page = 1, rowsPerPage = 10 }) => `attributes/asset-class/?page=${page}&page_size=${rowsPerPage}`,
  GET_AUDIT_CATEGORIES: 'attributes/categories',
  // These pointed at customers/create/, customers/<id>/update/ and
  // customers/<id>/delete/ - routes from the template's original product that
  // this API never defined, so create, edit and delete all 404'd.
  CREATE_CATEGORY: 'attributes/asset-class/create/',
  UPDATE_CATEGORY: (id) => `attributes/asset-class/${id}/`,
  DELETE_CATEGORY: (id) => `attributes/asset-class/${id}/`,
};
